import React, { useState } from "react";
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../../store/actions';
import ReactTable from "react-table";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import { FadeLoader } from 'react-spinners';
import { css } from 'react-emotion';
import checkPermissions from '../../shared/checkPermissions';
import UserHistoryViewDialog, { statusLabels } from './UserHistoryViewDialog';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class UserHistoryPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tab: 'all',
            viewEntry: null,
            viewOpen: false
        };
    }

    componentDidMount() {
        this.props.checkMaintenanceMode();
        this.props.getUserHistory();
    }

    getFilteredHistory() {
        const history = Array.isArray(this.props.userHistory) ? this.props.userHistory : [];
        if (this.state.tab === 'all') return history;
        if (this.state.tab === 'admin') return history.filter(h => h.type === 1);
        if (this.state.tab === 'perms') return history.filter(h => h.type === 2);
        return history;
    }

    render() {
        const hasUserAdmin = checkPermissions('UserAdmin');
        const hasUserPerms = checkPermissions('UserPerms');
        if (!hasUserAdmin && !hasUserPerms) {
            return <Redirect to="/dashboard" />;
        }
        if (this.props.maintenanceMode === 'yes') return <Redirect to="/components/maintenance_page" />;

        const loader = <FadeLoader
            className={override}
            sizeUnit={"px"}
            size={150}
            color={'#123abc'}
            loading={true}
        />;

        const filtered = this.getFilteredHistory();

        return (
            <div style={{ marginTop: 20 }}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="rose" icon>
                                <CardIcon
                                    color={this.state.tab === 'all' ? 'success' : 'rose'}
                                    onClick={() => this.setState({ tab: 'all' })}
                                    style={{ marginRight: 20 }}
                                    className="hovered"
                                >
                                    <strong>USER HISTORY</strong>
                                </CardIcon>
                                {hasUserAdmin && <CardIcon
                                    color={this.state.tab === 'admin' ? 'success' : 'rose'}
                                    onClick={() => this.setState({ tab: 'admin' })}
                                    style={{ marginRight: 20 }}
                                    className="hovered"
                                >
                                    <strong>USER ADMIN</strong>
                                </CardIcon>}
                                {hasUserPerms && <CardIcon
                                    color={this.state.tab === 'perms' ? 'success' : 'rose'}
                                    onClick={() => this.setState({ tab: 'perms' })}
                                    className="hovered"
                                >
                                    <strong>USER PERMISSIONS</strong>
                                </CardIcon>}
                            </CardHeader>
                            <CardBody>
                                {this.props.userHistoryLoading && loader}
                                {!this.props.userHistoryLoading && <ReactTable
                                    data={filtered.map((entry) => {
                                        let userName = entry.user_name;
                                        if (!userName) {
                                            try {
                                                const d = typeof entry.data === 'string' ? JSON.parse(entry.data) : entry.data;
                                                if (d && d.firstname && d.lastname) userName = d.firstname + ' ' + d.lastname;
                                                else if (d && d.name) userName = d.name;
                                            } catch(e) {}
                                        }
                                        return ({
                                        id: entry.id,
                                        date: new Date(entry.timestamp).toLocaleString(),
                                        timestamp: entry.timestamp,
                                        submitter: entry.submitter_name || 'N/A',
                                        user: userName || 'N/A',
                                        status: statusLabels[entry.status] || entry.status,
                                        actions: (
                                            <Button
                                                color="primary"
                                                size="sm"
                                                onClick={() => {
                                                    this.setState({ viewEntry: entry, viewOpen: true });
                                                }}
                                            >
                                                View
                                            </Button>
                                        )
                                    })})}
                                    filterable
                                    columns={[
                                        {
                                            Header: "Date",
                                            accessor: "date",
                                            sortMethod: (a, b) => {
                                                return new Date(a) - new Date(b);
                                            },
                                            filterMethod: (filter, row) => {
                                                return row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) !== -1;
                                            }
                                        },
                                        {
                                            Header: "Submitter",
                                            accessor: "submitter",
                                            filterMethod: (filter, row) => {
                                                return row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) !== -1;
                                            }
                                        },
                                        {
                                            Header: "User",
                                            accessor: "user",
                                            filterMethod: (filter, row) => {
                                                return row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) !== -1;
                                            }
                                        },
                                        {
                                            Header: "Actions",
                                            accessor: "actions",
                                            sortable: false,
                                            filterable: false
                                        }
                                    ]}
                                    defaultPageSize={10}
                                    showPaginationTop
                                    showPaginationBottom={false}
                                    className="-striped"
                                    defaultSorted={[{ id: "date", desc: true }]}
                                />}
                                {this.state.viewOpen && <UserHistoryViewDialog
                                    open={this.state.viewOpen}
                                    close={() => this.setState({ viewOpen: false, viewEntry: null })}
                                    entry={this.state.viewEntry}
                                />}
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        maintenanceMode: state.userPerms.maintenanceMode,
        userHistory: state.user.userHistory,
        userHistoryLoading: state.user.userHistoryLoading
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getUserHistory: () => dispatch(actions.getUserHistory()),
        checkMaintenanceMode: () => dispatch(actions.checkMaintenanceMode())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserHistoryPage);
